export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const END_AJAX_CALL = 'END_AJAX_CALL';

// Promo / influencer campaign system. See src/promos/ for the resolver
// and src/components/PromoCodeBar.jsx for the UI surface.
export const PROMOS_HYDRATED = 'PROMOS_HYDRATED';
export const SET_PROMO_URL_CODE = 'SET_PROMO_URL_CODE';
export const SET_PROMO_ENTERED_CODE = 'SET_PROMO_ENTERED_CODE';
export const CLEAR_PROMO_ENTERED_CODE = 'CLEAR_PROMO_ENTERED_CODE';
